/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bodymap_Nature_LimitationInputs */

const en_us2_bodymap_nature_limitation = /** @type {(inputs: Bodymap_Nature_LimitationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restricted movement`)
};

const pt_br2_bodymap_nature_limitation = /** @type {(inputs: Bodymap_Nature_LimitationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Movimento limitado`)
};

const es_419_bodymap_nature_limitation = /** @type {(inputs: Bodymap_Nature_LimitationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Movimiento limitado`)
};

const pt_pt2_bodymap_nature_limitation = /** @type {(inputs: Bodymap_Nature_LimitationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Movimento limitado`)
};

const fr_fr2_bodymap_nature_limitation = /** @type {(inputs: Bodymap_Nature_LimitationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mouvement limité`)
};

const de_de2_bodymap_nature_limitation = /** @type {(inputs: Bodymap_Nature_LimitationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eingeschränkte Bewegung`)
};

const it_it2_bodymap_nature_limitation = /** @type {(inputs: Bodymap_Nature_LimitationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Movimento limitato`)
};

/**
* | output |
* | --- |
* | "Restricted movement" |
*
* @param {Bodymap_Nature_LimitationInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const bodymap_nature_limitation = /** @type {((inputs?: Bodymap_Nature_LimitationInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bodymap_Nature_LimitationInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_bodymap_nature_limitation(inputs)
	if (locale === "es-419") return es_419_bodymap_nature_limitation(inputs)
	if (locale === "pt-PT") return pt_pt2_bodymap_nature_limitation(inputs)
	if (locale === "fr-FR") return fr_fr2_bodymap_nature_limitation(inputs)
	if (locale === "de-DE") return de_de2_bodymap_nature_limitation(inputs)
	if (locale === "it-IT") return it_it2_bodymap_nature_limitation(inputs)
	return en_us2_bodymap_nature_limitation(inputs)
});
export { bodymap_nature_limitation as "bodymap.nature.limitation" }